<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    class="icon-arrow-up"
    :class="{
      'icon-arrow-up--flipped': flipped,
    }"
  >
    <path
      d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconArrowUp',
    props: {
      width: {
        type: [Number, String],
        default: 24,
      },
      height: {
        type: [Number, String],
        default: 24,
      },
      flipped: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-arrow-up {
    fill: currentColor;
    transform: rotate(0deg);
    transition: transform 300ms ease-in-out;

    &--flipped {
      transform: rotate(180deg);
      transition: transform 300ms ease-in-out;
    }
  }
</style>
